
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSnowShowersPolartwilightColour as ObiLightningSnowShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-snow-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningSnowShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-snow-showers-polartwilight-colour',
   elementClass: ObiLightningSnowShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 